import React, { useEffect } from 'react';

const DraggableElementWrapper = ({ children, onClickOutside }) => {
    useEffect(() => {
        function handleClickOutside(event) {
            const isInDraggableElement = (target) => {
                for (let i = 0; i < 10; i++) {
                    const dataType = target.getAttribute('data-type');
                    if (dataType && dataType.indexOf('draggable') === 0) return true;
                    target = target.parentElement;
                    if (!target) return false;
                }
                return false;
            };

            if (!isInDraggableElement(event.target) && onClickOutside !== undefined) {
                onClickOutside();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (
        <>
            {children}
        </>
    );
};

export default DraggableElementWrapper;
